import { READING_ACTION_TYPES, READING_MODE_ACTION_TYPES } from '../actions/action_types';
import READING_MODES from '../../data/reading_modes';

export const initialState = {
  currentMode: READING_MODES.CLEAN,
  pendingChange: true,
  allModesCompleted: false,
  showAlerts: false,
  alerts: [],
  hasMetCompletionThreshold: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_MODE_ACTION_TYPES.ALL_MODES_COMPLETED: {
      const { hasMetCompletionThreshold = false } = payload || {};

      return {
        ...state,
        allModesCompleted: true,
        hasMetCompletionThreshold,
      };
    }

    case READING_ACTION_TYPES.SET_BOOK_STATE: {
      const currentMode = payload.mode;
      return {
        ...state,
        currentMode,
        pendingChange: !currentMode,
        allModesCompleted: false,
        showAlerts: payload.showAlerts !== undefined ? payload.showAlerts : state.showAlerts,
      };
    }
    case READING_MODE_ACTION_TYPES.MODE_CHANGED: {
      const currentMode = payload.mode;
      return {
        ...state,
        currentMode,
        pendingChange: !currentMode,
        allModesCompleted: false,
      };
    }
    case READING_MODE_ACTION_TYPES.CHANGE_REQUESTED:
      return { ...state, pendingChange: true };
    case READING_MODE_ACTION_TYPES.CHANGE_REQUEST_CANCELED: {
      return { ...state, pendingChange: false };
    }
    case READING_MODE_ACTION_TYPES.RETURN_TO_CHALLENGE:
      return { ...state, currentMode: READING_MODES.CHALLENGE };
    case READING_ACTION_TYPES.RETURN_TO_UNANSWERED_QUESTIONS:
      return {
        ...state,
        allModesCompleted: false,
        currentMode: READING_MODES.CHALLENGE,
        hasMetCompletionThreshold: false,
      };
    case READING_MODE_ACTION_TYPES.SET_SHOW_ALERTS:
      return { ...state, showAlerts: payload };

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default: {
      return state;
    }
  }
};
